export default __webpack_public_path__ + "static/media/header.cf39d46c.png";